import { MirrorFeedItemFnReq, MirrorFeedItemFnRes } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';
import { GetAuthDtoInteractor } from '../../../auth/domain/interactors/get-auth-dto.interactor';

export type MirrorFeedItemRequest = Omit<MirrorFeedItemFnReq, 'auth'>;
export type MirrorFeedItemResult = MirrorFeedItemFnRes;

export class MirrorFeedItemInteractor {
  private readonly mirrorFeedItemFn = httpsCallable<MirrorFeedItemFnReq, MirrorFeedItemFnRes>(
    this.functions,
    'mirrorFeedItem',
  );

  constructor(
    private readonly functions: Functions,
    private readonly getAuthDto: GetAuthDtoInteractor,
  ) {}

  public async execute(req: MirrorFeedItemRequest): Promise<MirrorFeedItemResult> {
    const res = await this.mirrorFeedItemFn({
      ...req,
      auth: await this.getAuthDto.execute(),
    });

    return res.data;
  }
}
